/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_008: Question = {
  id: 'gov-008-fonds-protection-biodiversite',
  oldId: '8',
  title: 'Création d\'un fond pour la protection de la biodiversité',
  number: '1.8',
  type: QuestionType.ACTIVITY,
  idEM: 13,
  frequency: 1,
  description: ['L\'organisme municipal a mis en place ou participe à un ou plusieurs fonds pour la biodiversité.'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_008_v2: Question = question_gov_008;
export const question_gov_008_v3: Question = question_gov_008;
